module.exports = __webpack_public_path__ + "img/pm-question.d4832af6.png";